let constant = {
    GOOGLE_MAPS_KEY: "AIzaSyCe1bqB7Phfav4FzI5bNUaEfjgKB1sN8pc",
    IP_ADDRESS: "YOUR_IP_ADDRESS" || "localhost",
    BACKEND_PORT: "BACKEND_PORT"
}

export default constant